// Applies the account preference before the main stylesheet to avoid theme flash.
import { Log } from './core/logger'

const root = document.documentElement
const preference = root.dataset.theme ?? 'auto'
const systemPreference = window.matchMedia('(prefers-color-scheme: dark)')

/**
 * Applies the saved preference or current system preference to the root element.
 */
const applyTheme = (): void => {
  const dark = preference === 'dark'
    || (preference === 'auto' && systemPreference.matches)
  root.classList.toggle('dark', dark)
}

Log.notice('Apply display theme', () => applyTheme())

if (preference === 'auto') {
  systemPreference.addEventListener('change', () => {
    Log.notice('Update system display theme', () => applyTheme())
  })
}
